import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  LinearProgress,
  Checkbox,
  Divider,
  FormHelperText
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import NumberFormat from 'react-number-format';


const RequestPromotionDiscountComplexForm = ({
  values,
  setFieldValue,
  touched,
  errors,
  classes
}) => {
  const {storeActiveCategoriesWithAllActiveParents, loadingCategories} = useSelector((state: IReduxState) => state.categories);
  const {store_products: {catalogActiveProducts}, productsLoading} = useSelector((state: IReduxState) => state.products);

  const renderOption = (option, { inputValue, type }) => {
    const optionText = type === 'categories' ? option?.nameWithPath : option.name;
    const matches = match(optionText, inputValue);
    const parts = parse(optionText, matches);

    return (
      <div>
        {parts.map((part, index) => (
          <span key={index} className={part.highlight ? 'text-primary font-bold' : ''}>
            {part.text}
          </span>
        ))}
        {type === 'listings' && Boolean(option.price) && (
          <span className="ml-2 text-green">${option.price}</span>
        )}
      </div>
    );
  };

  return (
    <>
      <FormControlLabel
        value="buyXGetY"
        control={
          <Radio
            size="small"
            color="primary"
            onClick={() => setFieldValue('discountType.name', 'Buy X Get Y')}
          />}
        label="Buy X Get Y"
      />
      {values.discountType.value === 'buyXGetY' &&
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} className="pl-10">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-5 mb-3">
            Customer Buys <span className="text-error">*</span>
          </Typography>
          <FormControl component="div">
            <RadioGroup
              name="buyXGetY.customerBuys.minBuy.name"
              value={values.buyXGetY.customerBuys.minBuy.name}
              onChange={(event) => setFieldValue('buyXGetY.customerBuys.minBuy.name', event.target.value)}
            >
              <FormControlLabel
                value="Minimum quantity of items"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => setFieldValue('buyXGetY.customerBuys.minBuy.value', '')}
                  />
                }
                label="Minimum quantity of items"
              />
              {values.buyXGetY.customerBuys.minBuy.name === 'Minimum quantity of items' &&
              <NumberFormat
                customInput={TextField}
                required
                size="small"
                label="Quantity"
                variant="outlined"
                name="buyXGetY.customerBuys.minBuy.value"
                className={`mx-8 my-2 ${classes.custom_input}`}
                value={values.buyXGetY.customerBuys.minBuy.value}
                onValueChange={(value) => {
                  setFieldValue('buyXGetY.customerBuys.minBuy.value', value.formattedValue);
                }}
                error={touched.buyXGetY?.customerBuys?.minBuy?.value
                  && values.buyXGetY.customerBuys.minBuy.name === 'Minimum quantity of items'
                  && Boolean(errors.buyXGetY?.customerBuys?.minBuy?.value)}
                helperText={touched.buyXGetY?.customerBuys?.minBuy?.value
                  && values.buyXGetY.customerBuys.minBuy.name === 'Minimum quantity of items'
                  && errors.buyXGetY?.customerBuys?.minBuy?.value}
              />
              }
              <FormControlLabel
                value="Minimum purchase amount"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => setFieldValue('buyXGetY.customerBuys.minBuy.value', '')}
                  />
                }
                label="Minimum purchase amount"
              />
              {values.buyXGetY.customerBuys.minBuy.name === 'Minimum purchase amount' &&
              <NumberFormat
                customInput={TextField}
                prefix={'$'}
                required
                size="small"
                label="Amount"
                variant="outlined"
                name="buyXGetY.customerBuys.minBuy.value"
                className={`mx-8 my-2 ${classes.custom_input}`}
                value={values.buyXGetY.customerBuys.minBuy.value}
                onValueChange={(value) => {
                  setFieldValue('buyXGetY.customerBuys.minBuy.value', value.formattedValue);
                }}
                error={touched.buyXGetY?.customerBuys?.minBuy?.value
                  && values.buyXGetY.customerBuys.minBuy.name === 'Minimum purchase amount'
                  && Boolean(errors.buyXGetY?.customerBuys?.minBuy?.value)}
                helperText={touched.buyXGetY?.customerBuys?.minBuy?.value
                  && values.buyXGetY.customerBuys.minBuy.name === 'Minimum purchase amount'
                  && errors.buyXGetY?.customerBuys?.minBuy?.value}
              />
              }
              {touched.buyXGetY?.customerBuys?.minBuy?.name && Boolean(errors.buyXGetY?.customerBuys?.minBuy?.name) &&
              <FormHelperText>
                <Typography color="error" variant="caption">
                  {errors.buyXGetY.customerBuys.minBuy.name}
                </Typography>
              </FormHelperText>
              }
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} className="pr-10">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-5 mb-3">
            Applies To <span className="text-error">*</span>
          </Typography>
          <FormControl component="fieldset" className="w-full">
            <RadioGroup
              aria-label="applies to"
              name="buyXGetY.customerBuys.appliesTo"
              value={values.buyXGetY.customerBuys.appliesTo.name}
              onChange={(event) => {
                setFieldValue('buyXGetY.customerBuys.appliesTo.name', event.target.value);
              }}
            >
              <FormControlLabel
                value="Storewide"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="Storewide"
              />
              <FormControlLabel
                value="All Products"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="All Products"
              />
              <FormControlLabel
                value="All Treatments"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="All Treatments"
              />
              <FormControlLabel
                value="Specific Categories/Listings"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="Specific Categories/Listings"
              />
              {values.buyXGetY.customerBuys.appliesTo.name === 'Specific Categories/Listings' &&
              <div className="ml-7 flex-column w-full">
                <FormControlLabel
                  name="Categories"
                  control={
                    <Checkbox
                      size="small"
                      color="primary"
                      checked={values.buyXGetY.customerBuys.appliesTo.isCategories}
                      onChange={(e) => setFieldValue('buyXGetY.customerBuys.appliesTo.isCategories', e.target.checked)}
                    />
                  }
                  label="Categories"
                />
                {values.buyXGetY.customerBuys.appliesTo.isCategories &&
                <>
                  {loadingCategories ?
                    <div className="my-5">
                      <span className="text-muted">Preparing Categories Data...</span>
                      <LinearProgress />
                    </div>
                    :
                    <Autocomplete
                      multiple
                      fullWidth
                      disableClearable
                      size="small"
                      className="my-5"
                      value={values.buyXGetY.customerBuys.appliesTo.value.categories}
                      options={storeActiveCategoriesWithAllActiveParents}
                      getOptionLabel={(option) => option.nameWithPath}
                      onChange={(e, value) => {
                        setFieldValue(
                          'buyXGetY.customerBuys.appliesTo.value.categories',
                          value !== null ? value : values.buyXGetY.customerBuys.appliesTo.value.categories
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="buyXGetY.customerBuys.appliesTo.value.categories"
                          variant="outlined"
                          label="Categories"
                          required
                          error={touched.buyXGetY?.customerBuys?.appliesTo?.value?.categories && Boolean(errors.buyXGetY?.customerBuys?.appliesTo?.value?.categories)}
                          helperText={touched.buyXGetY?.customerBuys?.appliesTo?.value?.categories && errors.buyXGetY?.customerBuys?.appliesTo?.value?.categories}
                        />
                      )}
                      renderOption={(option, { inputValue }) => renderOption(option, { inputValue, type: 'categories' })}
                    />
                  }
                </>
                }
                <FormControlLabel
                  name="Listings"
                  control={
                    <Checkbox
                      size="small"
                      color="primary"
                      checked={values.buyXGetY.customerBuys.appliesTo.isListings}
                      onChange={(e) => setFieldValue('buyXGetY.customerBuys.appliesTo.isListings', e.target.checked)}
                    />
                  }
                  label="Listings"
                />
                {values.buyXGetY.customerBuys.appliesTo.isListings &&
                <>
                  {productsLoading ?
                    <div className="my-5">
                      <span className="text-muted">Preparing Listings Data...</span>
                      <LinearProgress />
                    </div>
                    :
                    <Autocomplete
                      multiple
                      fullWidth
                      disableClearable
                      noOptionsText={
                        <Link
                          to="/request-sku" target="_blank" onMouseDown={() => {
                            window.open('/request-sku', '_blank');
                          }}
                        >
                          Request Listings
                        </Link>
                      }
                      size="small"
                      className="my-5"
                      value={values.buyXGetY.customerBuys.appliesTo.value.listings}
                      options={catalogActiveProducts}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, value) => {
                        setFieldValue(
                          'buyXGetY.customerBuys.appliesTo.value.listings',
                          value !== null ? value : values.buyXGetY.customerBuys.appliesTo.value.listings
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="buyXGetY.customerBuys.appliesTo.value.listings"
                          variant="outlined"
                          label="Listings"
                          required
                          error={touched.buyXGetY?.customerBuys?.appliesTo?.value?.listings && Boolean(errors.buyXGetY?.customerBuys?.appliesTo?.value?.listings)}
                          helperText={touched.buyXGetY?.customerBuys?.appliesTo?.value?.listings && errors.buyXGetY?.customerBuys?.appliesTo?.value?.listings}
                        />
                      )}
                      renderOption={(option, { inputValue }) => renderOption(option, { inputValue, type: 'listings' })}
                    />
                  }
                </>
                }
              </div>
              }
              {(touched.buyXGetY?.customerBuys?.appliesTo?.isCategories ||
                touched.buyXGetY?.customerBuys?.appliesTo?.isListings) &&
                (Boolean(errors.buyXGetY?.customerBuys?.appliesTo?.isCategories) ||
                Boolean(errors.buyXGetY?.customerBuys?.appliesTo?.isListings)) &&
                <FormHelperText>
                  <Typography color="error" variant="caption">
                    At least one needs to be selected
                  </Typography>
                </FormHelperText>
              }
              {touched.buyXGetY?.customerBuys?.appliesTo?.name && Boolean(errors.buyXGetY?.customerBuys?.appliesTo?.name) &&
              <FormHelperText>
                <Typography color="error" variant="caption">
                  {errors.buyXGetY.customerBuys.appliesTo.name}
                </Typography>
              </FormHelperText>
              }
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} md={6} className="pl-10">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-2 mb-3">
            Customer Gets <span className="text-error">*</span>
          </Typography>
          <div>Quantity</div>
          <NumberFormat
            customInput={TextField}
            required
            size="small"
            label="Quantity"
            variant="outlined"
            name="buyXGetY.customerGet.quantity"
            className={`my-2 ${classes.custom_input}`}
            value={values.buyXGetY.customerGet.quantity}
            onValueChange={(value) => {
              setFieldValue('buyXGetY.customerGet.quantity', value.formattedValue);
            }}
            error={touched.buyXGetY?.customerGet?.quantity && Boolean(errors.buyXGetY?.customerGet?.quantity)}
            helperText={touched.buyXGetY?.customerGet?.quantity && errors.buyXGetY?.customerGet?.quantity}
          />
        </Grid>
        <Grid item xs={12} md={6} className="pr-10 flex-column">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-2">
            Applies To <span className="text-error">*</span>
          </Typography>
          <FormControlLabel
            name="Categories"
            control={
              <Checkbox
                size="small"
                color="primary"
                checked={values.buyXGetY.customerGet.appliesTo.isCategories}
                onChange={(e) => setFieldValue('buyXGetY.customerGet.appliesTo.isCategories', e.target.checked)}
              />
            }
            label="Categories"
          />
          {values.buyXGetY.customerGet.appliesTo.isCategories &&
          <>
            {loadingCategories ?
              <div className="my-5">
                <span className="text-muted">Preparing Categories Data...</span>
                <LinearProgress />
              </div>
              :
              <Autocomplete
                multiple
                fullWidth
                disableClearable
                size="small"
                className="my-5"
                value={values.buyXGetY.customerGet.appliesTo.value.categories}
                options={storeActiveCategoriesWithAllActiveParents}
                getOptionLabel={(option) => option.nameWithPath}
                onChange={(e, value) => {
                  setFieldValue(
                    'buyXGetY.customerGet.appliesTo.value.categories',
                    value !== null ? value : values.buyXGetY.customerGet.appliesTo.value.categories
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="buyXGetY.customerGet.appliesTo.value.categories"
                    variant="outlined"
                    label="Categories"
                    required
                    error={touched.buyXGetY?.customerGet?.appliesTo?.value?.categories && Boolean(errors.buyXGetY?.customerGet?.appliesTo?.value?.categories)}
                    helperText={touched.buyXGetY?.customerGet?.appliesTo?.value?.categories && errors.buyXGetY?.customerGet?.appliesTo?.value?.categories}
                  />
                )}
                renderOption={(option, { inputValue }) => renderOption(option, { inputValue, type: 'categories' })}
              />
            }
          </>
          }
          <FormControlLabel
            name="Listings"
            control={
              <Checkbox
                size="small"
                color="primary"
                checked={values.buyXGetY.customerGet.appliesTo.isListings}
                onChange={(e) => setFieldValue('buyXGetY.customerGet.appliesTo.isListings', e.target.checked)}
              />
            }
            label="Listings"
          />
          {values.buyXGetY.customerGet.appliesTo.isListings &&
          <>
            {productsLoading ?
              <div className="my-5">
                <span className="text-muted">Preparing Listings Data...</span>
                <LinearProgress />
              </div>
              :
              <Autocomplete
                multiple
                fullWidth
                disableClearable
                noOptionsText={
                  <Link
                    to="/request-sku" target="_blank" onMouseDown={() => {
                      window.open('/request-sku', '_blank');
                    }}
                  >
                    Request Listings
                  </Link>
                }
                size="small"
                className="my-5"
                value={values.buyXGetY.customerGet.appliesTo.value.listings}
                options={catalogActiveProducts}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                  setFieldValue(
                    'buyXGetY.customerGet.appliesTo.value.listings',
                    value !== null ? value : values.buyXGetY.customerGet.appliesTo.value.listings
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="buyXGetY.customerGet.appliesTo.value.listings"
                    variant="outlined"
                    label="Listings"
                    required
                    error={touched.buyXGetY?.customerGet?.appliesTo?.value?.listings && Boolean(errors.buyXGetY?.customerGet?.appliesTo?.value?.listings)}
                    helperText={touched.buyXGetY?.customerGet?.appliesTo?.value?.listings && errors.buyXGetY?.customerGet?.appliesTo?.value?.listings}
                  />
                )}
                renderOption={(option, { inputValue }) => renderOption(option, { inputValue, type: 'listings' })}
              />
            }
          </>
          }
          {(touched.buyXGetY?.customerGet?.appliesTo?.isCategories ||
            touched.buyXGetY?.customerGet?.appliesTo?.isListings) &&
            (Boolean(errors.buyXGetY?.customerGet?.appliesTo?.isCategories) ||
            Boolean(errors.buyXGetY?.customerGet?.appliesTo?.isListings)) &&
            <FormHelperText>
              <Typography color="error" variant="caption">
                At least one needs to be selected
              </Typography>
            </FormHelperText>
          }
          {touched.buyXGetY?.customerGet?.appliesTo?.name && Boolean(errors.buyXGetY?.customerGet?.appliesTo?.name) &&
          <FormHelperText>
            <Typography color="error" variant="caption">
              {errors.buyXGetY.customerGet.appliesTo.name}
            </Typography>
          </FormHelperText>
          }
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} className="px-10">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-2 mb-3">
            Discount Value <span className="text-error">*</span>
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="applies to"
              name="buyXGetY.discountValue.name"
              value={values.buyXGetY.discountValue.name}
              onChange={(event) => {
                setFieldValue('buyXGetY.discountValue.name', event.target.value);
              }}
            >
              <FormControlLabel
                value="Percentage OFF"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('buyXGetY.discountValue.name', 'Percentage OFF');
                      setFieldValue('buyXGetY.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Percentage OFF</span>
                    {values.buyXGetY.discountValue.name === 'Percentage OFF' &&
                    <NumberFormat
                      customInput={TextField}
                      suffix={'%'}
                      required
                      size="small"
                      label="Discount"
                      variant="outlined"
                      name="buyXGetY.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.buyXGetY.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('buyXGetY.discountValue.value', value.formattedValue);
                      }}
                      error={touched.buyXGetY?.discountValue?.value && Boolean(errors.buyXGetY?.discountValue?.value)}
                      helperText={touched.buyXGetY?.discountValue?.value && errors.buyXGetY?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              <FormControlLabel
                value="Dollar OFF"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('buyXGetY.discountValue.name', 'Dollar OFF');
                      setFieldValue('buyXGetY.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Dollar OFF</span>
                    {values.buyXGetY.discountValue.name === 'Dollar OFF' &&
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      label="Discount"
                      variant="outlined"
                      name="buyXGetY.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.buyXGetY.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('buyXGetY.discountValue.value', value.formattedValue);
                      }}
                      error={touched.buyXGetY?.discountValue?.value && Boolean(errors.buyXGetY?.discountValue?.value)}
                      helperText={touched.buyXGetY?.discountValue?.value && errors.buyXGetY?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              <FormControlLabel
                value="Fixed Price"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('buyXGetY.discountValue.name', 'Fixed Price');
                      setFieldValue('buyXGetY.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Fixed Price</span>
                    {values.buyXGetY.discountValue.name === 'Fixed Price' &&
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      label="Price"
                      variant="outlined"
                      name="buyXGetY.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.buyXGetY.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('buyXGetY.discountValue.value', value.formattedValue);
                      }}
                      error={touched.buyXGetY?.discountValue?.value && Boolean(errors.buyXGetY?.discountValue?.value)}
                      helperText={touched.buyXGetY?.discountValue?.value && errors.buyXGetY?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              {touched.buyXGetY?.discountValue?.name && Boolean(errors.buyXGetY?.discountValue?.name) &&
              <FormHelperText>
                <Typography color="error" variant="caption">
                  {errors.buyXGetY.discountValue.name}
                </Typography>
              </FormHelperText>
              }
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Divider className="mb-5" />
        </Grid>
      </Grid>
      }
      <FormControlLabel
        value="everyNth"
        control={
          <Radio
            size="small"
            color="primary"
            onClick={() => setFieldValue('discountType.name', 'Every Nth')}
          />}
        label="Every Nth"
      />
      {values.discountType.value === 'everyNth' &&
      <Grid container spacing={3}>
        <Grid item xs={12} className="pl-10 mt-3">
          <FormControl component="div">
            <RadioGroup
              name="everyNth.discountOn.name"
              value={values.everyNth.discountOn.name}
              onChange={(event) => setFieldValue('everyNth.discountOn.name', event.target.value)}
            >
              <FormControlLabel
                value="Every quantity of item"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => setFieldValue('everyNth.discountOn.value', '')}
                  />
                }
                label={
                  <div className="flex items-center">
                    <div>Every</div>
                    <NumberFormat
                      customInput={TextField}
                      required
                      size="small"
                      variant="outlined"
                      name="everyNth.discountOn.value"
                      className={`mx-2 ${!errors.everyNth?.discountOn?.value && 'max-w-100'} ${classes.custom_input}`}
                      InputProps={{
                        disabled: values.everyNth.discountOn.name !== 'Every quantity of item'
                      }}
                      value={values.everyNth.discountOn.name === 'Every quantity of item' ? values.everyNth.discountOn.value : ''}
                      onValueChange={(value) => {
                        if (values.everyNth.discountOn.name === 'Every quantity of item') {
                          setFieldValue('everyNth.discountOn.value', value.formattedValue);
                        }
                      }}
                      error={touched.everyNth?.discountOn?.value
                        && values.everyNth.discountOn.name === 'Every quantity of item'
                        && Boolean(errors.everyNth?.discountOn?.value)}
                      helperText={touched.everyNth?.discountOn?.value
                        && values.everyNth.discountOn.name === 'Every quantity of item'
                        && errors.everyNth?.discountOn?.value}
                    />
                    <div>quantity of item</div>
                  </div>
                }
              />
              <FormControlLabel
                value="Every purchase amount"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => setFieldValue('everyNth.discountOn.value', '')}
                  />
                }
                label={
                  <div className="flex items-center">
                    <div>Every</div>
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      variant="outlined"
                      placeholder="$"
                      name="everyNth.discountOn.value"
                      className={`mx-2 ${!errors.everyNth?.discountOn?.value && 'max-w-100'} ${classes.custom_input}`}
                      value={values.everyNth.discountOn.name === 'Every purchase amount' ? values.everyNth.discountOn.value : ''}
                      onValueChange={(value) => {
                        if (values.everyNth.discountOn.name === 'Every purchase amount') {
                          setFieldValue('everyNth.discountOn.value', value.formattedValue);
                        }
                      }}
                      InputProps={{
                        disabled: values.everyNth.discountOn.name !== 'Every purchase amount'
                      }}
                      error={touched.everyNth?.discountOn?.value
                        && values.everyNth.discountOn.name === 'Every purchase amount'
                        && Boolean(errors.everyNth?.discountOn?.value)}
                      helperText={touched.everyNth?.discountOn?.value
                        && values.everyNth.discountOn.name === 'Every purchase amount'
                        && errors.everyNth?.discountOn?.value}
                    />
                    <div>purchase amount</div>
                  </div>
                }
              />
              {touched.everyNth?.discountOn?.name && Boolean(errors.everyNth?.discountOn?.name) &&
                <FormHelperText>
                  <Typography color="error" variant="caption">
                    {errors.everyNth.discountOn.name}
                  </Typography>
                </FormHelperText>
              }
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} className="px-10">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-2 mb-3">
            Discount Value <span className="text-error">*</span>
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              name="everyNth.discountValue.name"
              value={values.everyNth.discountValue.name}
              onChange={(event) => {
                setFieldValue('everyNth.discountValue.name', event.target.value);
              }}
            >
              <FormControlLabel
                value="Percentage OFF"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('everyNth.discountValue.name', 'Percentage OFF');
                      setFieldValue('everyNth.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Percentage OFF</span>
                    {values.everyNth.discountValue.name === 'Percentage OFF' &&
                    <NumberFormat
                      customInput={TextField}
                      suffix={'%'}
                      required
                      size="small"
                      label="Discount"
                      variant="outlined"
                      name="everyNth.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.everyNth.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('everyNth.discountValue.value', value.formattedValue);
                      }}
                      error={touched.everyNth?.discountValue?.value && Boolean(errors.everyNth?.discountValue?.value)}
                      helperText={touched.everyNth?.discountValue?.value && errors.everyNth?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              <FormControlLabel
                value="Dollar OFF"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('everyNth.discountValue.name', 'Dollar OFF');
                      setFieldValue('everyNth.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Dollar OFF</span>
                    {values.everyNth.discountValue.name === 'Dollar OFF' &&
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      label="Discount"
                      variant="outlined"
                      name="everyNth.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.everyNth.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('everyNth.discountValue.value', value.formattedValue);
                      }}
                      error={touched.everyNth?.discountValue?.value && Boolean(errors.everyNth?.discountValue?.value)}
                      helperText={touched.everyNth?.discountValue?.value && errors.everyNth?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              <FormControlLabel
                value="Fixed Price"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('everyNth.discountValue.name', 'Fixed Price');
                      setFieldValue('everyNth.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Fixed Price</span>
                    {values.everyNth.discountValue.name === 'Fixed Price' &&
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      label="Price"
                      variant="outlined"
                      name="everyNth.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.everyNth.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('everyNth.discountValue.value', value.formattedValue);
                      }}
                      error={touched.everyNth?.discountValue?.value && Boolean(errors.everyNth?.discountValue?.value)}
                      helperText={touched.everyNth?.discountValue?.value && errors.everyNth?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              {touched.everyNth?.discountValue?.name && Boolean(errors.everyNth?.discountValue?.name) &&
                <FormHelperText>
                  <Typography color="error" variant="caption">
                    {errors.everyNth.discountValue.name}
                  </Typography>
                </FormHelperText>
              }
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Divider className="mb-5" />
        </Grid>
      </Grid>
      }
      <FormControlLabel
        value="bundle"
        control={
          <Radio
            size="small"
            color="primary"
            onClick={() => setFieldValue('discountType.name', 'Bundle')}
          />}
        label="Bundle"
      />
      {values.discountType.value === 'bundle' &&
      <Grid container spacing={3}>
        <Grid item xs={12} className="pl-10 mt-3">
          {productsLoading ?
            <div className="my-5">
              <span className="text-muted">Preparing Listings Data...</span>
              <LinearProgress />
            </div>
            :
            <>
              <div>Specific Listings</div>
              <Autocomplete
                multiple
                fullWidth
                disableClearable
                noOptionsText={
                  <Link
                    to="/request-sku" target="_blank" onMouseDown={() => {
                      window.open('/request-sku', '_blank');
                    }}
                  >
                    Request Listings
                  </Link>
                }
                size="small"
                className="my-5"
                value={values.bundle.appliesTo.value || []}
                options={catalogActiveProducts}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => {
                  setFieldValue(
                    'bundle.appliesTo.value',
                    value !== null ? value : values.bundle.appliesTo.value
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="bundle.appliesTo.value"
                    variant="outlined"
                    label="Listings"
                    required
                    error={touched.bundle?.appliesTo?.value && Boolean(errors.bundle?.appliesTo?.value)}
                    helperText={touched.bundle?.appliesTo?.value && errors.bundle?.appliesTo?.value}
                  />
                )}
                renderOption={(option, { inputValue }) => renderOption(option, { inputValue, type: 'listings' })}
              />
            </>
          }
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} className="px-10">
          <Typography variant="body1" className="text-muted uppercase font-bold mt-2 mb-3">
            Discount Value <span className="text-error">*</span>
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              name="bundle.discountValue.name"
              value={values.bundle.discountValue.name}
              onChange={(event) => {
                setFieldValue('bundle.discountValue.name', event.target.value);
              }}
            >
              <FormControlLabel
                value="Percentage OFF"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('bundle.discountValue.name', 'Percentage OFF');
                      setFieldValue('bundle.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Percentage OFF</span>
                    {values.bundle.discountValue.name === 'Percentage OFF' &&
                    <NumberFormat
                      customInput={TextField}
                      suffix={'%'}
                      required
                      size="small"
                      label="Discount"
                      variant="outlined"
                      name="bundle.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.bundle.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('bundle.discountValue.value', value.formattedValue);
                      }}
                      error={touched.bundle?.discountValue?.value && Boolean(errors.bundle?.discountValue?.value)}
                      helperText={touched.bundle?.discountValue?.value && errors.bundle?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              <FormControlLabel
                value="Dollar OFF"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('bundle.discountValue.name', 'Dollar OFF');
                      setFieldValue('bundle.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Dollar OFF</span>
                    {values.bundle.discountValue.name === 'Dollar OFF' &&
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      label="Discount"
                      variant="outlined"
                      name="bundle.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.bundle.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('bundle.discountValue.value', value.formattedValue);
                      }}
                      error={touched.bundle?.discountValue?.value && Boolean(errors.bundle?.discountValue?.value)}
                      helperText={touched.bundle?.discountValue?.value && errors.bundle?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              <FormControlLabel
                value="Fixed Price"
                control={
                  <Radio
                    size="small"
                    color="primary"
                    onClick={() => {
                      setFieldValue('bundle.discountValue.name', 'Fixed Price');
                      setFieldValue('bundle.discountValue.value', '');
                    }}
                  />}
                label={
                  <div className="flex items-center">
                    <span>Fixed Price</span>
                    {values.bundle.discountValue.name === 'Fixed Price' &&
                    <NumberFormat
                      customInput={TextField}
                      prefix={'$'}
                      required
                      size="small"
                      label="Price"
                      variant="outlined"
                      name="bundle.discountValue.value"
                      className={`ml-4 ${classes.custom_input}`}
                      value={values.bundle.discountValue.value}
                      onValueChange={(value) => {
                        setFieldValue('bundle.discountValue.value', value.formattedValue);
                      }}
                      error={touched.bundle?.discountValue?.value && Boolean(errors.bundle?.discountValue?.value)}
                      helperText={touched.bundle?.discountValue?.value && errors.bundle?.discountValue?.value}
                    />
                    }
                  </div>
                }
              />
              {touched.bundle?.discountValue?.name && Boolean(errors.bundle?.discountValue?.name) &&
              <FormHelperText>
                <Typography color="error" variant="caption">
                  {errors.bundle.discountValue.name}
                </Typography>
              </FormHelperText>
              }
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      }
      {touched.discountType?.name && Boolean(errors.discountType?.name) &&
      <FormHelperText>
        <Typography color="error" variant="caption">
          {errors.discountType.name}
        </Typography>
      </FormHelperText>
      }
    </>
  );
};

export default RequestPromotionDiscountComplexForm;
